import type { FC } from 'react';
import track from 'react-tracking';
import Competitor, { CompetitorProps } from './Competitor';
import { CompetitorsWrapper } from './styled';
import { Row, Column } from '@simplywallst/ui-core';

export interface CompetitorsProps {
  list: CompetitorProps[];
}

const Competitors: FC<CompetitorsProps> = ({ list }) => (
  <CompetitorsWrapper>
    <hr />
    <h4>Similar Companies</h4>
    <Row>
      {list.map((n, i) => (
        <Column
          col={12}
          colLg={4}
          key={`competitor-holding-${n.companyId + i}`}
        >
          <Competitor
            index={i}
            points={n.points}
            companyId={n.companyId}
            companyName={n.companyName}
            uniqueSymbol={n.uniqueSymbol}
            canonicalUrl={n.canonicalUrl}
          />
        </Column>
      ))}
    </Row>
  </CompetitorsWrapper>
);

export default track({
  type: 'track',
  subject: 'relatedCompanies',
})(Competitors);
